import { Collection } from 'modules/core/lib/mobx-rest'

import IncidenceOption from 'modules/bookkeepers/store/models/IncidenceOption'

class IncidenceOptions extends Collection<IncidenceOption> {
  get cacheKey(): string {
    return 'incidenceOptions'
  }

  model() {
    return IncidenceOption
  }
}

const singleton: IncidenceOptions = new IncidenceOptions()

export default singleton
